<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">
    <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
    <div class="modal-header">
        <h3 class="modal-title font">{{titulo}}</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
        <div class="info-texto-condiciones-fondo" [ngStyle]="{'background-color': '#8edbfff5'}" *ngIf="(formGroup.get('tipo')?.value) && (formGroup.get('tipo')?.value?.id === 'DAE')">
            <label class="info-texto-condiciones-texto">Los datos de la campaña no podrán editarse en las dos horas previas a la fecha de inicio definida.</label>
            <label class="info-texto-condiciones-texto">Las campañas que no se ejecuten al menos 48 horas antes de la fecha de inicio establecida no podrán ser lanzadas.</label>
        </div>

        <form class="form-search py-3" [formGroup]="formGroup">

            <div class="row form">
                <div class="col-sm flex-grow-2">
                    <label for="modulo">Tipo Campaña <span class="oblig">*</span></label>
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <mat-select formControlName="tipo" id="tipo" placeholder="-- Tipo Campaña --">
                            <mat-option *ngFor="let tipo of tipoCampanias" [value]="tipo">
                                {{ tipo.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="controlHasError('tipo', 'required')">Campo obligatorio</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm flex-grow-0" *ngIf="(formGroup.get('tipo')?.value)">
                    <label for="firstname">Año <span class="oblig">*</span></label>
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input type="number" matInput formControlName="anio" id="anio" placeholder="Año" value=""
                            [min]="0" #anio>
                            <!-- (input)="anioValidation(anio.value) -->
                        <mat-error *ngIf="controlHasError('anio', 'required')">Campo obligatorio</mat-error>
                        <mat-error *ngIf="formGroup.get('anio')?.invalid && formGroup.get('anio')?.touched">Año
                            inválido (1900
                            a 2500)
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
            <div class="row-fields">
                <div class="field field-100" *ngIf="(formGroup.get('tipo')?.value) && formGroup.get('tipo')?.value.id === 'CVFPoseedor'">
                    <label for="campanaAsociada">Campaña de CVF gestor asociada <span class="oblig">*</span></label>
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <mat-select formControlName="campanaAsociada" id="campanaAsociada" placeholder="-- Seleccione Campaña --" [compareWith]="compararCampanas">
                            <mat-option *ngFor="let campana of campanasAsociadas" [value]="campana">
                                {{ campana.descripcion }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="controlHasError('campanaAsociada', 'required')">Campo obligatorio</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row-fields">
                <div class="field field-50" *ngIf="(formGroup.get('tipo')?.value)">
                    <label for="fechaInicio">Fecha Inicio <span class="oblig">*</span></label>

                    <div class="custom-mat-field">
                        <mat-form-field appearance="outline" class="custom-mat-form-field">
                            <input matInput [matDatepicker]="datepicker" formControlName="fechaInicio">
                            <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                            <mat-datepicker #datepicker>
                            </mat-datepicker>
                            <mat-error *ngIf="controlHasError('fechaInicio', 'matDatepickerParse')">Formato
                                incorrecto</mat-error>
                            <mat-error *ngIf="controlHasError('fechaInicio', 'required')">Campo obligatorio</mat-error>
                            <mat-error *ngIf="formGroup.get('fechaInicio')?.hasError('fechaNoCoincide')">
                                El año no coincide
                            </mat-error>    
                    </mat-form-field>
                    </div>
                </div>
                <div class="field field-50" *ngIf="(formGroup.get('tipo')?.value)">
                    <label for="horaInicio">Hora Inicio <span class="oblig">*</span></label>
                    <mat-form-field appearance="outline">
                        <input matInput [ngxMatTimepicker]="timepicker" [format]="24" formControlName="horaInicio">
                        <span *ngIf="!soloLectura">
                            <mat-icon matSuffix (click)="timepicker.open()">
                                schedule
                            </mat-icon>
                        </span>
                        <ngx-mat-timepicker #timepicker [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn">
                        </ngx-mat-timepicker>
                        <mat-error *ngIf="controlHasError('horaInicio', 'required')">Campo obligatorio</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row-fields">
                <div class="field field-50" *ngIf="(formGroup.get('tipo')?.value)">
                    <label for="fechaFinalizacion">Fecha Fin <span class="oblig">*</span></label>

                    <div class="custom-mat-field">
                        <mat-form-field appearance="outline" class="custom-mat-form-field">
                            <input matInput [matDatepicker]="datepicker2" formControlName="fechaFinalizacion">
                            <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
                            <mat-datepicker #datepicker2>
                            </mat-datepicker>
                            <mat-error *ngIf="controlHasError('fechaFinalizacion', 'matDatepickerParse')">Formato
                                incorrecto</mat-error>
                            <mat-error *ngIf="controlHasError('fechaFinalizacion', 'required')">Campo
                                obligatorio</mat-error>
                            <mat-error *ngIf="formGroup.get('fechaFinalizacion')?.hasError('fechaNoCoincide')">
                                El año no coincide
                            </mat-error>   
                        </mat-form-field>
                    </div>
                </div>
                <div class="field field-50" *ngIf="(formGroup.get('tipo')?.value)">
                    <label for="horaFinalizacion">Hora Fin <span class="oblig">*</span></label>
                    <mat-form-field appearance="outline">
                        <input matInput [ngxMatTimepicker]="timepicker2" [format]="24" formControlName="horaFinalizacion">
                        <span *ngIf="!soloLectura">
                            <mat-icon matSuffix (click)="timepicker2.open()">
                                schedule
                            </mat-icon>
                        </span>
                        <ngx-mat-timepicker #timepicker2 [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn">
                        </ngx-mat-timepicker>
                        <mat-error *ngIf="controlHasError('horaFinalizacion', 'required')">Campo obligatorio</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row-fields">
                <div class="field field-100" *ngIf="(formGroup.get('tipo')?.value)">
                    <label for="mensaje">Descripción <span class="oblig">*</span></label>

                    <mat-form-field appearance="outline" class="textarea-field">
                        <textarea class="form-control" matInput formControlName="descripcion" id="descripcion"
                            placeholder="Descripción" rows="4"></textarea>
                        <mat-error *ngIf="controlHasError('descripcion', 'required')">Campo obligatorio</mat-error>
                    </mat-form-field>

                </div>
            </div>
        </form>

    </div>
    <div class="modal-footer actions">
        <div class="note"><span *ngIf="soloLectura">* Campos Obligatorios</span></div>
        <div class="button-group">
            <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
                aria-label="Cancelar">Cancelar</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
                *ngIf="!soloLectura" aria-label="Guardar">Guardar</button>
                <!--Ejecutar una campaña de tipo DAE-->
            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="confirmacionEjecucionCampania()"
            *ngIf="canEjecutarCampania() && this.campania && formGroup.get('tipo')?.value.id === 'DAE'"
                aria-label="Guardar">Ejecutar Campaña</button>
                <!--Lanzar una campaña de tipo CVF-->
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="lanzarCampaniaCVF()"
            *ngIf="this.campania && ((formGroup.get('tipo')?.value?.id === 'CVFGestor' && campania?.estado?.id !== 2 && campania?.estado?.id !== 5) || canLanzarCampaniaCVFPoseedor())"
                aria-label="Guardar">Lanzar Campaña</button>
                <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="finalizarCampaniaCVF()"
            *ngIf="canFinalizarCampaniaCVF() && this.campania && (formGroup.get('tipo')?.value.id === 'CVFGestor' || formGroup.get('tipo')?.value.id === 'CVFPoseedor')"
                aria-label="Guardar">Finalizar Campaña</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="confirmacionEjecucionCampania()"
            *ngIf="canRelanzarCampania() && this.campania && formGroup.get('tipo')?.value.id === 'DAE'"
                aria-label="Guardar">Relanzar Campaña</button>
        </div>
    </div>
</div>

<!--Plantilla botones de timepicker-->
<ng-template #cancelBtn>
    <button class="btn btn-outline-primary" style="margin-right: 10px;" aria-label="CANCELAR"
        type="button">CANCELAR</button>
</ng-template>
<ng-template #confirmBtn>
    <button aria-label="GUARDAR" class="btn btn-primary" type="button">ACEPTAR</button>
</ng-template>